module.exports = __webpack_public_path__ + "img/icon-school3.f74cf129.png";